import Vue from 'vue';
import Vuex from 'vuex';
import seo, { seoPersistencePlugin } from './modules/seo';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    seo,
  },
  plugins: [seoPersistencePlugin],
});

store.dispatch('seo/init');

export default store;
